import {
  ActionPermissionsContext,
  ActionPermissionsContextState,
} from "@src/lib/contexts/ActionPermissionsContext";
import { useContext } from "react";

const useActionPermissions = (): ActionPermissionsContextState => {
  return useContext(ActionPermissionsContext);
};

export default useActionPermissions;
